import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchModes = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/work_modes/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити режими роботи");
    return response.json();
};

export const fetchNetworks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/active`);
    if (!response.ok) throw new Error("Не вдалося завантажити мережі");
    return response.json();
};

export const updateMode = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/work_modes/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити режим роботи");
    }
    return response.json();
};

export const createMode = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/work_modes/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати режим роботи");
    }
    return response.json();
};
